import backdrops from './libraries/backdrops.json';
import costumes from './libraries/costumes.json';
import sprites from './libraries/sprites.json';

// md5ext of every costume and backdrop the libraries offer. These are served
// with the editor, so a project that uses one does not need its own copy.
const libraryImages = new Set();
backdrops.forEach(backdrop => libraryImages.add(backdrop.md5ext));
costumes.forEach(costume => libraryImages.add(costume.md5ext));
sprites.forEach(sprite => (sprite.costumes || []).forEach(costume => libraryImages.add(costume.md5ext)));
// the blank backdrop of the default project, bundled in ./default-project
libraryImages.add('cd21514d0531fdffb22204e0ec5ed84a.svg');

export default libraryImages;
